module.exports = __webpack_public_path__ + "img/13.2ce4b172.jpg";